import React from "react";
import { Link, useLocation } from "react-router-dom";
import MSILKLogo from "../assets/icon.PNG";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Import Bootstrap JS

const Header = () => {
  const location = useLocation(); // Get current path

  const handleLinkClick = () => {
    const navbarCollapse = document.getElementById("navbarNav");
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };

  return (
    <header id="header" className="f">
      {/* Logo Section */}
      <nav className="navbar navbar-expand-sm navbar-light bg-light pt-4 pb-4">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          {/* Logo - Always left-aligned */}
          <span className="navbar-brand d-flex align-items-center me-auto">
            <Link className="ps-4" to="/" onClick={handleLinkClick}>
              <img src={MSILKLogo} alt="Avatar Logo" style={{ width: "140px" }} />
            </Link>
          </span>

          {/* Navbar Toggle Button for Small Screens */}
          <button
            className="navbar-toggler border-0"
            type="button"
            style={{ border: "none", outline: "none", boxShadow: "none" }}
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation links - Centered */}
          <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
          <ul className="navbar-nav d-flex gap-lg-5 gap-1">
              <li className="nav-item">
                <Link
                  className={`nav-link link ${location.pathname === "/Aboutus" ? "active" : ""}`}
                  to="/Aboutus"
                  onClick={handleLinkClick}
                >
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link link ${location.pathname === "/Service" ? "active" : ""}`}
                  to="/Service"
                  onClick={handleLinkClick}
                >
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link link ${location.pathname === "/Contactus" ? "active" : ""}`}
                  to="/Contactus"
                  onClick={handleLinkClick}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Icons - Right aligned */}
          <div className="d-flex justify-content-end">
            <div className="pe-1 ">
                <Link className="link pt-2" to="/Login">
                  <i className="bi bi-person " style={{ fontSize: "25px" }}></i>
                </Link>
            </div>
            <div className="">                
                      <i className="bi bi-power link" style={{ fontSize: "25px" }}></i>                               
            </div>

          </div> 
        </div>
      </nav>
    </header>
  );
};

export default Header;
